import React, { useState } from "react";
import Dropdown from "rc-dropdown";
import DatePicker from "../../../elements/datePicker/DatePicker";
import { useTranslation } from "react-i18next";
import { getEndOfDayFromDate, getStartOfDayFromDate, TimestampToDate } from "../../../../utils/timestampToDate";
import ProjectsSelect from "../../../elements/projects/ProjectsSelect";
import MappedServicesFilter from "../../../elements/serviceReletionships/mappedServices/MappedServicesFilter";
import SwapStatusSelect from "../../../elements/swap/SwapStatusSelect";
import DefaultButton from "../../../styles/materialButtonStyle";

import {
  StyledFilterBlock, StyledFilterBlockTitle, StyledFilterCloseBtn,
  StyledFilterDropdownWrapper, StyledFilterGroup,
  StyledFilterWrapper, StyledSelectGroup,
  StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";
import { Tooltip } from "@material-ui/core";
import { StyledDatepicker } from "../../../styles/styledDatepicker";
import { StyledTooltip } from "../../../styles/styledTooltip";
import { DelayInput } from "react-delay-input/lib/Component";

const CashFlowSwapFilter = ({ filterData, setFilterData, userId }) => {
  const { t } = useTranslation("cashFlow");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "id": "",
    "referenceId": "",
    "inConnection.project.user.email": null,
    "inConnection.project.name": null,
    "status.value": null,
    "note": "",
    "inConnection.service.name": null,
    "inPaymentSystem.subName": null,
    "inCurrency.asset": null,
    "outConnection.service.name": null,
    "outPaymentSystem.subName": null,
    "outCurrency.asset": null,
    "inAmount[gte]": "",
    "inAmount[lte]": "",
    "outAmount[gte]": "",
    "outAmount[lte]": "",
    "createdAt[gte]": null,
    "createdAt[lte]": null,
    "updatedAt[gte]": null,
    "updatedAt[lte]": null,
    "itemsPerPage": filterData["itemsPerPage"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    if (filterData["currentTab"]) {
      DEFAULT_FILTER_DATA.currentTab = filterData["currentTab"];
    }

    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }));
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("swap.filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>

            <StyledFilterBlockTitle>
              {t("swap.filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <StyledFilterGroup>
                <label htmlFor="id">
                  Id
                  <Tooltip
                    title={t("swap.filter.tooltips.id")}
                    arrow
                    placement="top"
                  >
                    <StyledTooltip className="icon-light-help" />
                  </Tooltip>
                </label>
                <DelayInput
                  id="id"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "id": event.target.value, page: 1 })}
                  name="id"
                  value={filterData["id"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="referenceId">
                  Reference Id
                  <Tooltip
                    title={t("swap.filter.tooltips.referenceId")}
                    arrow
                    placement="top"
                  >
                    <StyledTooltip className="icon-light-help" />
                  </Tooltip>
                </label>
                <DelayInput
                  id="referenceId"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "referenceId": event.target.value, page: 1 })}
                  name="referenceId"
                  value={filterData["referenceId"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="inConnection.project.user.email">
                  {t("swap.filter.user")}
                </label>
                <DelayInput
                  id="inConnection.project.user.email"
                  delayTimeout={2000}
                  onChange={event => setFilterData({
                    ...filterData,
                    "inConnection.project.user.email": event.target.value,
                    page: 1
                  })}
                  name="inConnection.project.user.email"
                  value={filterData["inConnection.project.user.email"]}
                  type="text"
                  placeholder={t("swap.filter.userPlaceholder")}
                />
              </StyledFilterGroup>
              <StyledSelectGroup>
                <ProjectsSelect
                  checkedProjects={filterData["inConnection.project.name"]}
                  setCheckedProjects={(data) => setFilterData({
                    ...filterData,
                    "inConnection.project.name": data,
                    page: 1
                  })}
                  isObject={false}
                  defaultOption={true}
                  userId={userId}
                />
              </StyledSelectGroup>
              <StyledSelectGroup>
                <SwapStatusSelect
                  checkedStatus={filterData["status.value"]}
                  setCheckedStatus={(data) => setFilterData({ ...filterData, "status.value": data, page: 1 })}
                  defaultOption={true}
                />
              </StyledSelectGroup>
              <StyledFilterGroup>
                <label htmlFor="note">
                  {t("swap.filter.note")}
                </label>
                <DelayInput
                  id="note"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "note": event.target.value, page: 1 })}
                  name="note"
                  value={filterData["note"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("swap.filter.iGive")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <MappedServicesFilter
                checkedService={filterData["inConnection.service.name"]}
                setCheckedService={data => handleChangeFilterData(data, "inConnection.service.name")}

                checkedPaymentSystem={filterData["inPaymentSystem.subName"]}
                setCheckedPaymentSystem={data => handleChangeFilterData(data, "inPaymentSystem.subName")}

                checkedCurrency={filterData["inCurrency.asset"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "inCurrency.asset")}
              />
              <StyledFilterGroup>
                <label htmlFor="inAmount[gte]">
                  {t("swap.filter.inAmountFrom")}
                </label>
                <DelayInput
                  id="inAmount[gte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "inAmount[gte]": event.target.value, page: 1 })}
                  name="inAmount[gte]"
                  value={filterData["inAmount[gte]"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="inAmount[lte]">
                  {t("swap.filter.inAmountTo")}
                </label>
                <DelayInput
                  id="inAmount[lte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "inAmount[lte]": event.target.value, page: 1 })}
                  name="inAmount[lte]"
                  value={filterData["inAmount[lte]"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("swap.filter.iReceive")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <MappedServicesFilter
                checkedService={filterData["outConnection.service.name"]}
                setCheckedService={data => handleChangeFilterData(data, "outConnection.service.name")}

                checkedPaymentSystem={filterData["outPaymentSystem.subName"]}
                setCheckedPaymentSystem={data => handleChangeFilterData(data, "outPaymentSystem.subName")}

                checkedCurrency={filterData["outCurrency.asset"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "outCurrency.asset")}
              />
              <StyledFilterGroup>
                <label htmlFor="outAmount[gte]">
                  {t("swap.filter.outAmountFrom")}
                </label>
                <DelayInput
                  id="outAmount[gte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "outAmount[gte]": event.target.value, page: 1 })}
                  name="outAmount[gte]"
                  value={filterData["outAmount[gte]"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="outAmount[lte]">
                  {t("swap.filter.outAmountTo")}
                </label>
                <DelayInput
                  id="outAmount[lte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "outAmount[lte]": event.target.value, page: 1 })}
                  name="outAmount[lte]"
                  value={filterData["outAmount[lte]"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("swap.filter.date")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledDatepicker>
                <label htmlFor="createdAtFrom">
                  {t("swap.filter.createdAtFrom")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="createdAtFrom"
                  name="createdAtFrom"
                  className="date-input"
                  onChange={dateFrom => setFilterData({
                    ...filterData,
                    "createdAt[gte]": getStartOfDayFromDate(dateFrom),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["createdAt[gte]"])}
                />
              </StyledDatepicker>
              <StyledDatepicker>
                <label htmlFor="createdAtTo">
                  {t("swap.filter.createdAtTo")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="createdAtTo"
                  name="createdAtTo"
                  className="date-input"
                  onChange={dateTo => setFilterData({
                    ...filterData,
                    "createdAt[lte]": getEndOfDayFromDate(dateTo),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["createdAt[lte]"])}
                />
              </StyledDatepicker>
              <StyledDatepicker>
                <label htmlFor="updatedAtFrom">
                  {t("swap.filter.updatedAtFrom")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="updatedAtFrom"
                  name="updatedAtFrom"
                  className="date-input"
                  onChange={dateFrom => setFilterData({
                    ...filterData,
                    "updatedAt[gte]": getStartOfDayFromDate(dateFrom),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["updatedAt[gte]"])}
                />
              </StyledDatepicker>
              <StyledDatepicker>
                <label htmlFor="updatedAtTo">
                  {t("swap.filter.updatedAtTo")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="updatedAtTo"
                  name="updatedAtTo"
                  className="date-input"
                  onChange={dateTo => setFilterData({
                    ...filterData,
                    "updatedAt[lte]": getEndOfDayFromDate(dateTo),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["updatedAt[lte]"])}
                />
              </StyledDatepicker>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>
        }
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        align={{ overflow: { adjustX: true, adjustY: false } }}
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("swap.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default CashFlowSwapFilter;